// extracted by mini-css-extract-plugin
module.exports = {"root":"filter-block_root__1kXWJ","title":"filter-block_title__2zVr-","vertical":"filter-block_vertical__15NAM"};